<div class="mb-5" *transloco="let t">
  <div class="row justify-content-center">
    <div
      class="col-12 d-flex justify-content-center mb-5"
      [class.col-md-4]="this.isOldDashboard"
      [class.col-md-6]="!this.isOldDashboard"
      *ngFor="let item of navItems$.asObservable() | withLoader | async; let i = index"
    >
      <ng-container *ngIf="item.isExternalLink; else internalBlock">
        <ng-container *ngIf="item.click; else externalLink">
          <div class="w-100" (click)="item.onClick()">
            <ng-container *ngTemplateOutlet="externalLinkContent"></ng-container>
          </div>
        </ng-container>
        <ng-template #externalLink>
          <a href="{{ item.link }}" target="{{ item.target }}" class="w-100" [class.disabled]="item.disabled">
            <ng-container *ngTemplateOutlet="externalLinkContent"></ng-container>
          </a>
        </ng-template>

        <ng-template #externalLinkContent>
          <div class="card" [class.redesign-card]="!this.isOldDashboard">
            <div class="badge" *ngIf="item?.target === 'management' && this.isOldDashboard">
              <img src="assets/img/iconsDefault/star.svg" class="checkmark" />
              <div class="text-wrap">{{ t('management/enrolmentPromo') }}</div>
            </div>
            <div class="card-body">
              <div class="card-icons mb-5">
                <img class="card-first-icon" src="{{ item.iconPath }}" />
                <img class="card-second-icon" src="{{ item.secondIconPath }}" />
              </div>
              <div class="separator" *ngIf="!this.isOldDashboard"></div>
              <div class="card-text">
                <div class="card-heading mb-3">{{ item.headline }}</div>
                <div class="card-description">{{ item.description }}</div>
              </div>
            </div>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #internalBlock>
        <a
          [routerLink]="item.link"
          target="{{ item.target }}"
          [queryParams]="i === 5 ? { product: productType.QUESTIONNAIRE } : undefined"
          class="w-100"
          [class.disabled]="item.disabled"
        >
          <div class="card">
            <div class="card-body">
              <div class="card-icons mb-5">
                <img class="card-first-icon" src="{{ item.iconPath }}" />
                <img class="card-second-icon" src="{{ item.secondIconPath }}" />
              </div>
              <div class="card-text">
                <div class="card-heading mb-3">{{ item.headline }}</div>
                <div class="card-description">{{ item.description }}</div>
              </div>
            </div>
          </div>
        </a>
      </ng-template>
    </div>
  </div>
</div>

<app-diagnostic-video></app-diagnostic-video>
